import script from "./WidthBandView.vue?vue&type=script&setup=true&lang=ts"
export * from "./WidthBandView.vue?vue&type=script&setup=true&lang=ts"

import "./WidthBandView.vue?vue&type=style&index=0&id=2e4c808a&lang=css"

const __exports__ = script;

export default __exports__